import { useTranslations } from 'next-intl';

export const ProductNotFound = () => {
  const t = useTranslations('navigation');

  return (
    <div className="flex w-full items-center justify-center py-xs">
      <p className="text-body">{t('product_not_found')}</p>
    </div>
  );
};
